// Define the LinkedProducts class
class LinkedProducts {
  /*
  * ##################################
  * CONSTRUCTOR & DATA INITIALIZATION
  * ##################################
  */
  constructor(scriptId) {
    this.scriptId = scriptId // The ID of the script tag to fetch data from
    this.data = null // The fetched data

    // Store references to the DOM elements we'll manipulate
    this.product = document.querySelector('[data-linked-product]')
    this.container = this.product && this.product.querySelector('[data-linked-product-container]')
    this.productTitle = this.product && this.product.querySelector('[data-product-title]')
    this.productBreadcrumb = this.product && this.product.querySelector('[data-product-breadcrumb]')
    this.productSKU = this.product && this.product.querySelector('[data-product-sku]')
    this.productAccordionReviews = this.product && this.product.querySelector('[data-accordion-reviews-content]')
    this.productShortDescription = this.product && this.product.querySelector('[data-short-description]')
    this.productPrice = this.product && this.product.querySelector('[data-product-price]')
    this.productComparePrice = this.product && this.product.querySelector('[data-compare-price]')
    this.defaultCompareAtPrice = this.product.compareAtPriceLabel;
    this.defaultOurPrice = this.product.regularPriceLabel;
    this.productBadgeDiscount = this.product && this.product.querySelector('[data-badge-discount]')
    this.productStockMessage = this.product && this.product.querySelector('[data-stock-message]')
    this.productAvailableElement = this.product && this.product.querySelector('[data-product-available]')
    this.productSoldOutElement = this.product && this.product.querySelector('[data-product-soldout]')
    this.productAddonsContainer = this.product && this.product.querySelector('[data-product-addons]')
    this.productAddonsHeading = this.product && this.product.querySelector('[data-product-addons-heading]')
    this.productColorLabel = this.product && this.product.querySelector('[data-color-label]')
    this.productId = this.product && this.product.querySelector('input[name="id"]')
    this.productImages = this.product && this.product.querySelector('[data-product-images]')
    this.productThumbs = this.product && this.product.querySelector('[data-product-thumbs]')
    this.productHighlights = this.product && document.querySelector('[data-product-highlights]')
    this.productInfoCards = this.product && document.querySelectorAll('[data-product-info-card]')
    this.productFeatures = this.product && document.querySelector('[data-features-variant]')
    this.productCollectionVideo = this.product && document.querySelector('[data-product-collection-video]')
    this.inStockMessageElement = this.product && this.product.querySelector('[data-stock-message]')
    this.productRecentlyAddedContainer = this.product && document.querySelector('[data-recently-added-container]')
    this.productRecentlyAddedCount = this.product && document.querySelector('[data-recently-added-count]')
    this.calloutTextOne = this.product && document.querySelector('[data-callout-one]')
    this.calloutTextTwo = this.product && document.querySelector('[data-callout-two]')
    this.calloutTextThree = this.product && document.querySelector('[data-callout-three]')
    this.aboveTitleText = this.product && document.querySelector('[data-above-title-text]')
    this.productOverlayBadge = document.querySelector('.product-gallery__overlay-badge');
    this.productOverlayBadgeText = document.querySelector('.product-gallery__overlay-badge-text');
    this.productDescription = this.product && this.product.querySelector('[data-short-description]')
    this.productDescriptionMetafield = this.product && this.product.querySelector('[data-short-description-metafield]')
    this.stickyAtcContainer = this.product && document.querySelector('[data-sticky-atc]')
  }

  // Method to fetch and parse linked product data from the script tag
  initializeData() {
    const scriptTag = document.getElementById(this.scriptId)
    if (scriptTag) {
      try {
        this.data = JSON.parse(scriptTag.innerHTML)
      } catch (e) {
        console.error('Error parsing JSON data from script tag:', e)
      }
    }
  }

  // Method to retrieve color options from linked product data
  getColorOptions() {
    // Ensure there are products and each has variants
    if (!this.data.products || !this.data.products.every((product) => product.variants)) return []
    // Extract color options
    const colorOptions = this.data.products.map((product) => product.variants[0].title)
    return Array.from(new Set(colorOptions)) // Remove duplicates
  }

  // Method to retrieve product level addon products from linked product data
  getAddonOptions() {
    // Ensure there are products and each has variants
    if (!this.data.products || !this.data.products.every((product) => product.variants)) return []
    // Extract addon options
    const addonOptions = this.data.products.map((product) => product.addons)
    return Array.from(new Set(addonOptions)) // Remove duplicates
  }

  /*
  * ##################################
  * DOM MANIPULATION AND EVENT HANDLING
  * ##################################
  */
  handleColorOptionClick(event) {
    const clickedOption = event.currentTarget
    const newState = {
      color: clickedOption.getAttribute('data-value') // The clicked color option
    }

    // find the product from JSON data with the matching color
    const matchingProduct = this.data.products.find((product) => product.title.includes(newState.color))

    this.updateURL(newState, matchingProduct) // Update the URL to reflect clicked color
    this.updatePageState(newState) // Update the page state to reflect clicked color
    this.updateProductDetails(matchingProduct, newState.color) // Update the product details
    this.updateATCState(clickedOption) // Update the ATC button state
    this.renderAddonProductOptions()
  }

  // Method to update the browser's URL to reflect the selected option
  updateURL(state, matchingProduct) {
    const newUrl = this.buildNewUrl(state, matchingProduct) // Generate a new URL based on the state
    history.pushState(state, '', newUrl) // Update the browser's URL
  }

  // Method to clear the active state from color options
  clearActiveState() {
    const activeOption = this.container && this.container.querySelector('input:checked')
    if (activeOption) {
      activeOption.checked = false // Remove checked attribute
    }
  }

  // Method to set the clicked option as the active one
  updateActiveSwatch(clickedOption) {
    this.clearActiveState() // First clear the active state
    if (clickedOption) {
      let selectedIndex = clickedOption.dataset.index
      clickedOption.checked = true // Then set the clicked option as active
      this.productColorLabel.setAttribute('data-color-label', clickedOption.value)
      this.productColorLabel.setAttribute('data-selected-index', selectedIndex)
    }
  }

  updateStickyAtcContainer(matchingProduct){
    if(this.stickyAtcContainer){
      let stickyTitle = this.stickyAtcContainer.querySelector('.sticky-atc__title') || null;
      stickyTitle && matchingProduct.title ? stickyTitle.innerText = matchingProduct.title : null;

      let stickyImage = this.stickyAtcContainer.querySelector('.sticky-atc__image-wrapper img') || null;
      if(stickyImage && matchingProduct.media){
        stickyImage.src = matchingProduct.media[1].src.src
        stickyImage.setAttribute('srcset', matchingProduct.media[1].datasrc)
      }

      let stickyPrice = this.stickyAtcContainer.querySelector('[data-product-price]')
      let stickyComparePrice = this.stickyAtcContainer.querySelector('[data-compare-price]')

      if (stickyPrice && matchingProduct && matchingProduct.variants) {
        let variant = matchingProduct.variants[0]; // We're taking the first variant for this example
        const srSaleEl = document.querySelector('[data-sr-sale]');
    
        // Retrieve labels from metafields, providing defaults
        const ourPriceLabel = matchingProduct.regularPriceLabel || this.defaultOurPrice;
        const suggestedPriceLabel = matchingProduct.compareAtPriceLabel || this.defaultCompareAtPrice;
    
        // Check if price is properly defined and convert it to a number
        let price = variant.price;
        if (typeof price === 'string') {
          price = parseFloat(price.replace(/[^0-9.-]+/g, ''));
        }
    
        // Check if compare price is properly defined and convert it to a number
        let comparePrice = variant.compare_at_price;
        if (comparePrice && typeof comparePrice === 'string') {
          comparePrice = parseFloat(comparePrice.replace(/[^0-9.-]+/g, ''));
        }
    
        // Format prices as strings with dollar signs
        let formattedPrice = '$' + (Number.isInteger(price) ? price.toFixed(0) : price.toFixed(2));
    
        // Ensure 'deal' class is always present
        this.productPrice.classList.add('deal');
    
        // Check if compare price is present and different from the actual price
        if (comparePrice && comparePrice !== price) {
          let formattedComparePrice = '$' + (Number.isInteger(comparePrice) ? comparePrice.toFixed(0) : comparePrice.toFixed(2));
          stickyPrice.textContent = ourPriceLabel + ' ' + formattedPrice; // Update the price
          stickyPrice.classList.remove('no-sale'); // Remove 'no-sale' because it's on sale
    
          if (stickyComparePrice) {
            stickyComparePrice.textContent = suggestedPriceLabel + ' ' + formattedComparePrice;
            // stickyComparePrice.style.display = 'inline';
          }
    
          // Ensure sale price element is created if not already present
          if (!srSaleEl) {
            const newSrSaleEl = document.createElement('p');
            newSrSaleEl.setAttribute('data-sr-sale', '');
            newSrSaleEl.textContent = 'Sale Price';
            newSrSaleEl.classList.add('sr-only');
            stickyPrice.insertAdjacentElement('beforebegin', newSrSaleEl);
          }
        } else {
          // If not on sale, display only the regular price without the label
          this.productPrice.textContent = formattedPrice;
          this.productPrice.classList.add('no-sale'); // Add 'no-sale' because it's not on sale
    
          if (this.productComparePrice) {
            this.productComparePrice.style.display = 'none';
          }
          if (srSaleEl) {
            srSaleEl.remove();
          }
        }
      }
    }
  }

  // A unified method to update all the product details
  updateProductDetails(matchingProduct, selectedColor) {
    if (matchingProduct) {
      this.updateProductTitle(matchingProduct)
      this.updateProductBreadcrumb(matchingProduct)
      this.updateProductDescription(matchingProduct)
      this.updateProductSku(matchingProduct)
      this.updateProductAccordionReviews(matchingProduct)
      this.updateProductPrice(matchingProduct)
      this.updateProductBadgeDiscount(matchingProduct)
      this.updateProductId(matchingProduct)
      !document.querySelector('.main-product') ? this.updateProductImages(matchingProduct) : this.updateProductImagesV2(matchingProduct);
      this.updateProductThumbs(matchingProduct)
      this.updateProductInfoCard(matchingProduct)
      this.updateProductFeatures(matchingProduct)
      this.updateProductCollectionVideo(matchingProduct)
      this.updateInStockMessage(matchingProduct)
      this.updateProductCallouts(matchingProduct)
      this.updateAboveTitleText(matchingProduct)
      this.updateRecentlyAddedCount(matchingProduct)
      this.updateStickyAtcContainer(matchingProduct)
      
      if (matchingProduct.type == 'bundle') {
        
        this.updateBundleJSON(matchingProduct)
          .then(() => {
            const event = new CustomEvent('linked-product:updated')
            document.dispatchEvent(event)
          })
          .catch(error => {
            console.error('Error updating bundle:', error)
          })
      }
      
      this.updateProductHighlights(matchingProduct)
      this.updateProductOverlayBadge(matchingProduct);
    }
  }

  // Method to update the product title based on the selected color
  updateProductTitle(matchingProduct) {
    if (this.productTitle && matchingProduct) {
      this.productTitle.textContent = matchingProduct.title // update the title
    }
  }

  // Method to update the product breadcrumb based on the selected color
  updateProductBreadcrumb(matchingProduct) {
    if (this.productBreadcrumb && matchingProduct) {
      this.productBreadcrumb.textContent = matchingProduct.title // update the breadcrumb
    }
  }

  // Method to update the product description based on the selected color
  updateProductDescription(matchingProduct) {
    if (this.productDescription) {
      this.productDescription.innerHTML = matchingProduct.short_description
    }
    if (this.productDescriptionMetafield) {
      this.productDescriptionMetafield.innerHTML = matchingProduct.short_description_metafield
    }
  }  

  updateProductSku(matchingProduct) {
    if (this.productSKU && matchingProduct) {
      this.productSKU.innerHTML = "SKU " + matchingProduct.sku;
    }
  } 
  
  updateProductAccordionReviews(matchingProduct) {
    if (this.productAccordionReviews && matchingProduct) {
      if(matchingProduct.collection_reviews && matchingProduct.collection_reviews.length > 0) {
        let reviews = this.productAccordionReviews.querySelector('[data-reviews]')
        reviews.innerHTML = ""
        matchingProduct.collection_reviews.forEach(review => {
          this.productAccordionReviews.classList.contains('hide') ? this.productAccordionReviews.classList.remove('hide') : null
          let template = null
          if(review.review_content_complete.length > 100){
            template = `
            <div class="accordion-review">
            <div class="accordion-review__stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="103" height="18" viewBox="0 0 103 18" fill="none">
                <path d="M19.3647 7.08123C19.2436 6.75346 18.9201 6.52755 18.5481 6.51105H12.702L10.8461 1.17203C10.714 0.814087 10.3427 0.581291 9.93675 0.601845C9.53935 0.599188 9.18612 0.837081 9.06448 1.18931L7.20857 6.52832H1.38103C0.989588 6.52582 0.640345 6.75681 0.514033 7.10176C0.387721 7.4467 0.512686 7.8282 0.824261 8.04882L5.55682 11.3835L3.70091 16.7571C3.56981 17.1099 3.70235 17.501 4.02717 17.7198C4.35199 17.9387 4.79245 17.9336 5.1114 17.7074L10.0667 14.2518L15.0405 17.7074C15.1954 17.8172 15.3841 17.8777 15.5787 17.8802C15.875 17.8841 16.1548 17.7533 16.3284 17.5297C16.502 17.3062 16.5478 17.0179 16.451 16.7571L14.5951 11.3835L19.2348 8.03154C19.485 7.77023 19.5366 7.39255 19.3647 7.08123Z" fill="#282828"/>
                <path d="M40.3647 7.08123C40.2436 6.75346 39.9201 6.52755 39.5481 6.51105H33.702L31.8461 1.17203C31.714 0.814087 31.3427 0.581291 30.9368 0.601845C30.5393 0.599188 30.1861 0.837081 30.0645 1.18931L28.2086 6.52832H22.381C21.9896 6.52582 21.6403 6.75681 21.514 7.10176C21.3877 7.4467 21.5127 7.8282 21.8243 8.04882L26.5568 11.3835L24.7009 16.7571C24.5698 17.1099 24.7023 17.501 25.0272 17.7198C25.352 17.9387 25.7924 17.9336 26.1114 17.7074L31.0667 14.2518L36.0405 17.7074C36.1954 17.8172 36.3841 17.8777 36.5787 17.8802C36.875 17.8841 37.1548 17.7533 37.3284 17.5297C37.502 17.3062 37.5478 17.0179 37.451 16.7571L35.5951 11.3835L40.2348 8.03154C40.485 7.77023 40.5366 7.39255 40.3647 7.08123Z" fill="#282828"/>
                <path d="M61.3647 7.08123C61.2436 6.75346 60.9201 6.52755 60.5481 6.51105H54.702L52.8461 1.17203C52.714 0.814087 52.3427 0.581291 51.9368 0.601845C51.5393 0.599188 51.1861 0.837081 51.0645 1.18931L49.2086 6.52832H43.381C42.9896 6.52582 42.6403 6.75681 42.514 7.10176C42.3877 7.4467 42.5127 7.8282 42.8243 8.04882L47.5568 11.3835L45.7009 16.7571C45.5698 17.1099 45.7023 17.501 46.0272 17.7198C46.352 17.9387 46.7924 17.9336 47.1114 17.7074L52.0667 14.2518L57.0405 17.7074C57.1954 17.8172 57.3841 17.8777 57.5787 17.8802C57.875 17.8841 58.1548 17.7533 58.3284 17.5297C58.502 17.3062 58.5478 17.0179 58.451 16.7571L56.5951 11.3835L61.2348 8.03154C61.485 7.77023 61.5366 7.39255 61.3647 7.08123Z" fill="#282828"/>
                <path d="M82.3647 7.08123C82.2436 6.75346 81.9201 6.52755 81.5481 6.51105H75.702L73.8461 1.17203C73.714 0.814087 73.3427 0.581291 72.9368 0.601845C72.5393 0.599188 72.1861 0.837081 72.0645 1.18931L70.2086 6.52832H64.381C63.9896 6.52582 63.6403 6.75681 63.514 7.10176C63.3877 7.4467 63.5127 7.8282 63.8243 8.04882L68.5568 11.3835L66.7009 16.7571C66.5698 17.1099 66.7023 17.501 67.0272 17.7198C67.352 17.9387 67.7924 17.9336 68.1114 17.7074L73.0667 14.2518L78.0405 17.7074C78.1954 17.8172 78.3841 17.8777 78.5787 17.8802C78.875 17.8841 79.1548 17.7533 79.3284 17.5297C79.502 17.3062 79.5478 17.0179 79.451 16.7571L77.5951 11.3835L82.2348 8.03154C82.485 7.77023 82.5366 7.39255 82.3647 7.08123Z" fill="#282828"/>
                <path d="M102.37 7.08123C102.255 6.75346 101.949 6.52755 101.596 6.51105H96.058L94.2998 1.17203C94.1746 0.814087 93.8228 0.581291 93.4383 0.601845C93.0618 0.599188 92.7271 0.837081 92.6119 1.18931L90.8537 6.52832H85.3328C84.962 6.52582 84.6311 6.75681 84.5115 7.10176C84.3918 7.4467 84.5102 7.8282 84.8054 8.04882L89.2888 11.3835L87.5306 16.7571C87.4064 17.1099 87.532 17.501 87.8397 17.7198C88.1474 17.9387 88.5647 17.9336 88.8669 17.7074L93.5613 14.2518L98.2734 17.7074C98.4201 17.8172 98.5989 17.8777 98.7833 17.8802C99.064 17.8841 99.329 17.7533 99.4935 17.5297C99.658 17.3062 99.7013 17.0179 99.6096 16.7571L97.8514 11.3835L102.247 8.03154C102.484 7.77023 102.533 7.39255 102.37 7.08123Z" fill="#282828"/>
                </svg>
            </div>
              <div class="accordion-review__heading">${review.review_heading}</div>
              <div class="accordion-review__content" data-accordion-reviews-content>
                <read-more-content class="collapsed">
                  <span data-truncated-review>${review.review_content_truncated}</span>
                  <span data-complete-review>${review.review_content_complete}</span>
                  <div>
                  <button>
                    <span data-read-more-indicator>
                      Read More
                    </span>
                    <span data-read-less-indicator>
                      Read Less
                    </span>
                  </button>
                  </div>
                </read-more-content>
              </div>
            `
          }else{
          template = `
            <div class="accordion-review">
            <div class="accordion-review__stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="103" height="18" viewBox="0 0 103 18" fill="none">
                <path d="M19.3647 7.08123C19.2436 6.75346 18.9201 6.52755 18.5481 6.51105H12.702L10.8461 1.17203C10.714 0.814087 10.3427 0.581291 9.93675 0.601845C9.53935 0.599188 9.18612 0.837081 9.06448 1.18931L7.20857 6.52832H1.38103C0.989588 6.52582 0.640345 6.75681 0.514033 7.10176C0.387721 7.4467 0.512686 7.8282 0.824261 8.04882L5.55682 11.3835L3.70091 16.7571C3.56981 17.1099 3.70235 17.501 4.02717 17.7198C4.35199 17.9387 4.79245 17.9336 5.1114 17.7074L10.0667 14.2518L15.0405 17.7074C15.1954 17.8172 15.3841 17.8777 15.5787 17.8802C15.875 17.8841 16.1548 17.7533 16.3284 17.5297C16.502 17.3062 16.5478 17.0179 16.451 16.7571L14.5951 11.3835L19.2348 8.03154C19.485 7.77023 19.5366 7.39255 19.3647 7.08123Z" fill="#282828"/>
                <path d="M40.3647 7.08123C40.2436 6.75346 39.9201 6.52755 39.5481 6.51105H33.702L31.8461 1.17203C31.714 0.814087 31.3427 0.581291 30.9368 0.601845C30.5393 0.599188 30.1861 0.837081 30.0645 1.18931L28.2086 6.52832H22.381C21.9896 6.52582 21.6403 6.75681 21.514 7.10176C21.3877 7.4467 21.5127 7.8282 21.8243 8.04882L26.5568 11.3835L24.7009 16.7571C24.5698 17.1099 24.7023 17.501 25.0272 17.7198C25.352 17.9387 25.7924 17.9336 26.1114 17.7074L31.0667 14.2518L36.0405 17.7074C36.1954 17.8172 36.3841 17.8777 36.5787 17.8802C36.875 17.8841 37.1548 17.7533 37.3284 17.5297C37.502 17.3062 37.5478 17.0179 37.451 16.7571L35.5951 11.3835L40.2348 8.03154C40.485 7.77023 40.5366 7.39255 40.3647 7.08123Z" fill="#282828"/>
                <path d="M61.3647 7.08123C61.2436 6.75346 60.9201 6.52755 60.5481 6.51105H54.702L52.8461 1.17203C52.714 0.814087 52.3427 0.581291 51.9368 0.601845C51.5393 0.599188 51.1861 0.837081 51.0645 1.18931L49.2086 6.52832H43.381C42.9896 6.52582 42.6403 6.75681 42.514 7.10176C42.3877 7.4467 42.5127 7.8282 42.8243 8.04882L47.5568 11.3835L45.7009 16.7571C45.5698 17.1099 45.7023 17.501 46.0272 17.7198C46.352 17.9387 46.7924 17.9336 47.1114 17.7074L52.0667 14.2518L57.0405 17.7074C57.1954 17.8172 57.3841 17.8777 57.5787 17.8802C57.875 17.8841 58.1548 17.7533 58.3284 17.5297C58.502 17.3062 58.5478 17.0179 58.451 16.7571L56.5951 11.3835L61.2348 8.03154C61.485 7.77023 61.5366 7.39255 61.3647 7.08123Z" fill="#282828"/>
                <path d="M82.3647 7.08123C82.2436 6.75346 81.9201 6.52755 81.5481 6.51105H75.702L73.8461 1.17203C73.714 0.814087 73.3427 0.581291 72.9368 0.601845C72.5393 0.599188 72.1861 0.837081 72.0645 1.18931L70.2086 6.52832H64.381C63.9896 6.52582 63.6403 6.75681 63.514 7.10176C63.3877 7.4467 63.5127 7.8282 63.8243 8.04882L68.5568 11.3835L66.7009 16.7571C66.5698 17.1099 66.7023 17.501 67.0272 17.7198C67.352 17.9387 67.7924 17.9336 68.1114 17.7074L73.0667 14.2518L78.0405 17.7074C78.1954 17.8172 78.3841 17.8777 78.5787 17.8802C78.875 17.8841 79.1548 17.7533 79.3284 17.5297C79.502 17.3062 79.5478 17.0179 79.451 16.7571L77.5951 11.3835L82.2348 8.03154C82.485 7.77023 82.5366 7.39255 82.3647 7.08123Z" fill="#282828"/>
                <path d="M102.37 7.08123C102.255 6.75346 101.949 6.52755 101.596 6.51105H96.058L94.2998 1.17203C94.1746 0.814087 93.8228 0.581291 93.4383 0.601845C93.0618 0.599188 92.7271 0.837081 92.6119 1.18931L90.8537 6.52832H85.3328C84.962 6.52582 84.6311 6.75681 84.5115 7.10176C84.3918 7.4467 84.5102 7.8282 84.8054 8.04882L89.2888 11.3835L87.5306 16.7571C87.4064 17.1099 87.532 17.501 87.8397 17.7198C88.1474 17.9387 88.5647 17.9336 88.8669 17.7074L93.5613 14.2518L98.2734 17.7074C98.4201 17.8172 98.5989 17.8777 98.7833 17.8802C99.064 17.8841 99.329 17.7533 99.4935 17.5297C99.658 17.3062 99.7013 17.0179 99.6096 16.7571L97.8514 11.3835L102.247 8.03154C102.484 7.77023 102.533 7.39255 102.37 7.08123Z" fill="#282828"/>
                </svg>
            </div>
              <div class="accordion-review__heading">${review.review_heading}</div>
              <div class="accordion-review__content" data-accordion-reviews-content>
                 ${review.review_content_complete}
              </div
            </div>
            `
          }
          reviews.innerHTML += template
        })
        reviews.innerHTML += `
        <a class="read-more-button" href="#BVRRContainer">
          READ MORE REVIEWS
        </a>
        `
      }else {
        !this.productAccordionReviews.classList.contains('hide') ? this.productAccordionReviews.classList.add('hide') : null
      }
    }
  } 

  // Method to update the product price based on the selected color
  updateProductPrice(matchingProduct) {
    if (this.productPrice && matchingProduct && matchingProduct.variants) {
      let variant = matchingProduct.variants[0]; // We're taking the first variant for this example
      const srSaleEl = document.querySelector('[data-sr-sale]');

      // Retrieve labels from metafields, providing defaults
      const ourPriceLabel = matchingProduct.regularPriceLabel === null ? this.defaultOurPrice : matchingProduct.regularPriceLabel;
      const suggestedPriceLabel = matchingProduct.compareAtPriceLabel === null ? this.defaultCompareAtPrice : matchingProduct.compareAtPriceLabel;

      // Check if price is properly defined and convert it to a number
      let price = variant.price;
      if (typeof price === 'string') {
        price = parseFloat(price.replace(/[^0-9.-]+/g, ''));
      }
  
      // Check if compare price is properly defined and convert it to a number
      let comparePrice = variant.compare_at_price;
      if (comparePrice && typeof comparePrice === 'string') {
        comparePrice = parseFloat(comparePrice.replace(/[^0-9.-]+/g, ''));
      }
  
      // Format prices as strings with dollar signs
      let formattedPrice = '$' + (Number.isInteger(price) ? price.toFixed(0) : price.toFixed(2));
  
      // Ensure 'deal' class is always present
      this.productPrice.classList.add('deal');
  
      // Check if compare price is present and different from the actual price
      if (comparePrice && comparePrice !== price) {
        let formattedComparePrice = '$' + (Number.isInteger(comparePrice) ? comparePrice.toFixed(0) : comparePrice.toFixed(2));
        this.productPrice.textContent = ourPriceLabel + ' ' + formattedPrice; // Update the price
        this.productPrice.classList.remove('no-sale'); // Remove 'no-sale' because it's on sale
  
        if (this.productComparePrice) {
          this.productComparePrice.textContent = suggestedPriceLabel + ' ' + formattedComparePrice;
          this.productComparePrice.style.display = 'block';
        }
  
        // Ensure sale price element is created if not already present
        if (!srSaleEl) {
          const newSrSaleEl = document.createElement('p');
          newSrSaleEl.setAttribute('data-sr-sale', '');
          newSrSaleEl.textContent = 'Sale Price';
          newSrSaleEl.classList.add('sr-only');
          this.productPrice.insertAdjacentElement('beforebegin', newSrSaleEl);
        }
      } else {
        // If not on sale, display only the regular price without the label
        this.productPrice.textContent = formattedPrice;
        this.productPrice.classList.add('no-sale'); // Add 'no-sale' because it's not on sale
  
        if (this.productComparePrice) {
          this.productComparePrice.style.display = 'none';
        }
        if (srSaleEl) {
          srSaleEl.remove();
        }
      }
    }
  }  

  //Method to update the discount badge based on selected color
  updateProductBadgeDiscount(matchingProduct) {
    if (this.productBadgeDiscount && matchingProduct) {
      this.productBadgeDiscount.textContent = matchingProduct.badgeDiscount // update the breadcrumb
    }
  }

  //Method to update the hidden product variant id for adding to cart based on selected color
  updateProductId(matchingProduct) {
    if (this.productId && matchingProduct) {
      this.productId.value = matchingProduct.variants[0].id// update the variant id
    }
  }

  // update the main product image gallery
  updateProductImages(matchingProduct) {
    if (!this.productImages || !matchingProduct || !matchingProduct.media) return;

    const galleryTop = this.productImages;
    if (!galleryTop) return;

    let has_video = false
    matchingProduct.media.forEach((mediaItem, index) => {
      if(mediaItem.type == 'video' || mediaItem.type == 'external_video') {
        has_video = true
      }
    })

    let slides = matchingProduct.media.map((mediaItem, index) => {
      if (index === 0) mediaItem = matchingProduct.media[1];
      else if (index === 1) mediaItem = matchingProduct.media[0];

      let lazyClass = '';
      index === 0 ? lazyClass = ' lazy' : '';

      let paddingTopPercentage = (1 / mediaItem.aspect_ratio) * 100; // Calculate padding-top percentage
      if (mediaItem.type === 'image') {
        return `
                <div class="active-wrapper slide" data-media-id="${mediaItem.id}" style="padding-top: ${paddingTopPercentage}%">
                    ${index == 0 && has_video ? '<dynamic-play-button><button><span class="dynamic-svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none"><path d="M10.5312 6.53125L0.734376 12.1875L0.734377 0.875021L10.5312 6.53125Z" fill="#19341A"/></svg></span><span class="dynamic-video__text">Play Video</span></button></dynamic-play-button>' : null}
                    <a href="${mediaItem.master.src}" class="productImage">
                        <div>
                            <img
                                data-srcset="${mediaItem.datasrc}"
                                data-sizes="auto"
                                data-file="${mediaItem.master.src}"
                                class="large-thumb"
                                itemprop="image"
                                alt="${mediaItem.alt}"
                                height="650px"
                                width="650px"
                            >
                        </div>
                    </a>
                </div>
            `;
      } else if (mediaItem.type === 'video') {
        return `
                <div class="active-wrapper slide video-slide" data-media-id="${mediaItem.id}">
                    <video controls width="${mediaItem.width}" height="${mediaItem.height}">
                        <source src="${mediaItem.src}" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            `;
      } else if (mediaItem.type === 'external_video' && mediaItem.host === 'vimeo') {
        return `
                <div class="active-wrapper slide external-video-slide" data-media-id="${mediaItem.id}">
                    <div class="video-wrap" style="padding-top: ${paddingTopPercentage}%">
                        <iframe src="https://player.vimeo.com/video/${mediaItem.external_id}" width="${mediaItem.width}" height="${mediaItem.height}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                    </div>
                </div>
            `;
      }
    });

    $('.main-images').slick('destroy');
    galleryTop.innerHTML = slides.join('');
    $('.main-images').slick('init');
    $('.main-images').slick('slickGoTo', 0);
  }

  updateProductImagesV2(matchingProduct) {
    if (!this.productImages || !matchingProduct || !matchingProduct.media) return;

    const galleryTop = this.productImages;
    if (!galleryTop) return;

    let has_video = false
    matchingProduct.media.forEach((mediaItem, index) => {
      if(mediaItem.type == 'video' || mediaItem.type == 'external_video') {
        has_video = true
      }
    })

    let slides = matchingProduct.media.map((mediaItem, index) => {
      if (index === 0) mediaItem = matchingProduct.media[1];
      else if (index === 1) mediaItem = matchingProduct.media[0];

      let lazy = '';
      index === 0 ? lazy = 'lazy' : lazy = 'eager';

      let paddingTopPercentage = (1 / mediaItem.aspect_ratio) * 100; // Calculate padding-top percentage

      if (mediaItem.type === 'image') {
        return `
                <div class="active-wrapper slide${index > 4 ? ' hide-initially-hidden initially-hidden-images': ''}" data-media-id="${mediaItem.id}" style="padding-top: ${paddingTopPercentage}%" data-index="${index}">
                    ${index == 0 && has_video ? '<dynamic-play-button><button><span class="dynamic-svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none"><path d="M10.5312 6.53125L0.734376 12.1875L0.734377 0.875021L10.5312 6.53125Z" fill="#19341A"/></svg></span><span class="dynamic-video__text">Play Video</span></button></dynamic-play-button>' : ''}
                    <a href="${mediaItem.master.src}" class="productImage">
                        <div>
                            <img
                                srcset="${mediaItem.datasrc}"
                                sizes="auto"
                                data-file="${mediaItem.master.src}"
                                class="large-thumb"
                                itemprop="image"
                                alt="${mediaItem.alt}"
                                height="700px"
                                width="700px"
                                loading="${lazy}"
                            >
                        </div>
                    </a>
                </div>
            `;
      } else if (mediaItem.type === 'video') {
        return `
                <div class="active-wrapper slide external-video-slide">
                <video-button>
                  <button class="video-wrap" data-html='${mediaItem.media_tag}'>
                  <div class="play-svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="143" height="143" viewBox="0 0 143 143" fill="none">
                      <path d="M103.991 74.425L55.1365 102.631L55.1365 46.2188L103.991 74.425Z" fill="white"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M71.4209 135.235C106.662 135.235 135.23 106.666 135.23 71.425C135.23 36.184 106.662 7.61548 71.4209 7.61548C36.1798 7.61548 7.61133 36.184 7.61133 71.425C7.61133 106.666 36.1798 135.235 71.4209 135.235ZM71.4209 142.235C110.528 142.235 142.23 110.532 142.23 71.425C142.23 32.318 110.528 0.615479 71.4209 0.615479C32.3139 0.615479 0.611328 32.318 0.611328 71.425C0.611328 110.532 32.3139 142.235 71.4209 142.235Z" fill="white"/>
                    </svg>
                  </div>
                    <img src="${mediaItem.preview_image}">
                  </button>
                </video-button>
                </div>
            `;
      } else if (mediaItem.type === 'external_video' && mediaItem.host === 'vimeo') {
        return `
                <div class="active-wrapper slide external-video-slide">
                <video-button>
                  <button class="video-wrap" data-html='${mediaItem.media_tag}'>
                    <img src="${mediaItem.preview_image}">
                  </button>
                </video-button>
                </div>
            `;
      }
    });

    let isSlicked = document.querySelector(".main-product__images-wrapper.slick-initialized")
    let show_multicolumn = true
    matchingProduct.tags.forEach((tag) => {
      if(tag.includes('category:cutlery') || tag.includes('category:electrics') || tag == 'thirdparty') {
        show_multicolumn = false
      }
    })
    const multicolumn_loader = "<multicolumn-loader class='multicolumn-gallery desktop'></multicolumn-loader>"

    if (multicolumn_loader && show_multicolumn) {
      slides.splice(3, 0, multicolumn_loader)
    }
    if(isSlicked) {
      $('.main-product__images-wrapper').slick('destroy');
      galleryTop.innerHTML = slides.join('');
      $('.main-product__images-wrapper').slick('init');
      $('.main-product__images-wrapper').slick('slickGoTo', 0);
    } else {
      let gallery_see_more  = document.querySelector('[data-see-more-button]');
      if(gallery_see_more){
        gallery_see_more.classList.contains('expanded') ? gallery_see_more.classList.remove('expanded'): null
      }
      galleryTop.innerHTML = slides.join('');
    }

    // Reinitialize PhotoSwipe
    if($('.active-wrapper a.productImage').length > 0) {
      $('.active-wrapper a.productImage, .active-wrapper iframe').photoSwipe({
        getDoubleTapZoom: function(isMouseClick, item) {
          return item.initialZoomLevel;
        },
        index: function() {
          return $(this).closest('.slide').index();
        },
        beforeOpen: function() {
          let slides = this.container.querySelectorAll('.pswp__item img');
          
          const clickedIndex = this.options.index();
          
          if (slides.length > 1) {
            const first = slides[0];
            const second = slides[1];
            second.parentNode.insertBefore(second, first);
          }
          if (slides.length > 2) {
            const third = slides[2];
            const second = slides[1];
            third.parentNode.insertBefore(third, second);
          }
          
          this.options.index = clickedIndex;
        }
      });
    }
  }

  updateProductThumbs(matchingProduct) {
    if (!this.productThumbs || !matchingProduct || !matchingProduct.media) return;
    let container = this.productThumbs;
    if (!container) return;

    let slides = matchingProduct.media.map((media, index) => {
      if (index === 0) media = matchingProduct.media[1];
      else if (index === 1) media = matchingProduct.media[0];

      let activeClass = index === 0 ? ' active' : '';

      if (media.type === 'image') {
        return `
                <div class="slide${activeClass}" data-media-type="image">
                    <a class="gallery" href="${media.src.src}" data-media-id="${media.id}" variant-id="" tabindex="0">
                        <img src="${media.src.src}" loading="lazy" alt="${media.alt}" width="198" height="198">
                    </a>
                </div>
            `;
      } else if (media.type === 'external_video') {
        return `
                <div class="slide${activeClass}" data-media-type="external_video">
                    <a class="gallery" href="#" data-media-id="${media.id}" variant-id="" tabindex="0">
                        <img src="${media.preview_image}" loading="lazy" alt="${media.alt}" width="198" height="198">
                    </a>
                </div>
            `;
      }
    });

    $('.thumbs').slick('destroy');
    container.innerHTML = slides.join('');
    $('.thumbs').slick({
      autoplay: false,
      speed: 700,
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      prevArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-up up-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M26.984 23.5l1.516-1.617L16 8.5 3.5 21.883 5.008 23.5 16 11.742z"/></svg>',
      nextArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-down down-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M26.984 8.5l1.516 1.617L16 23.5 3.5 10.117 5.008 8.5 16 20.258z"/></svg>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            swipeToSlide: true,
            vertical: false,
            verticalSwiping: false,
            arrows: false,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false,
            prevArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left left-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M24.333 28.205l-1.797 1.684L7.666 16l14.87-13.889 1.797 1.675L11.269 16z"/></svg>',
            nextArrow: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right right-arrow" viewBox="0 0 32 32"><path fill="{{settings.content_text_color}}" d="M7.667 3.795l1.797-1.684L24.334 16 9.464 29.889l-1.797-1.675L20.731 16z"/></svg>'
          }
        }
      ]
    });
    const thumbs = document.querySelectorAll('.thumbs.switch a.gallery');
    if (thumbs) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('thumbnails:updated', { detail: { mediaId: thumb.getAttribute('data-media-id') } }));
        })
      })
    }
  }

  // Method to update the product info cards based on color selected
  updateProductInfoCard(matchingProduct) {
    if (matchingProduct) {
      const cards = this.productInfoCards;
      if (!cards.length) return;

      let infoCardContent = matchingProduct.info_card.map((content) => {
        let title = content.title != null ? content.title : '';
        let subtitle = content.subtitle != null ? content.subtitle : '';
        let description = content.description != null ? content.description : '';
        return `
        <img
          src="${content.image[0].src}"
          alt="${content.image[0].alt}"
          height="${content.image[0].height}px"
          width="${content.image[0].width}px"
          loading="lazy"
        >
        <div class="product-info-card__text">
          <h3 class="product-info-card__heading">${title}</h3>
          <p class="product-info-card__subheading">${subtitle}</p>
          <p class="product-info-card__info">${description}</p>
        </div>
        `
      });

      cards.forEach(card => {
        card.innerHTML = '';
        card.innerHTML = infoCardContent.join('');
      });
    }
  }

  // Method to update the product highlights section
  updateProductHighlights(matchingProduct) {
    if (this.productHighlights && matchingProduct) {
      const container = this.productHighlights
      if (!container) return
      
      matchingProduct.highlights.forEach((highlight, index) => {
        let titleText = highlight.tab_title;

        // Normalize titleText to always be a string
        titleText = Array.isArray(titleText) ? titleText[0] : titleText;
                
        // Increment index here if necessary
        index += 1;
        
        if (titleText) {
          // Check for specific title text and product type
          if (titleText.toLowerCase() === 'dimensions &amp; components' && matchingProduct.type === 'bundle') {
            titleText = 'Bundle Components';
          }   
        }     
      
        // desktop title
        if (container.querySelector(`[data-highlight-title-desktop-${index}]`) != null) {
          let title = container.querySelector(`[data-highlight-title-desktop-${index}]`);
          if (title) {
            title.innerHTML = titleText;
          }
        }
        // mobile title
        if (container.querySelector(`[data-highlight-title-${index}]`) != null) {
          let title = container.querySelector(`[data-highlight-title-${index}]`);
          if (title) {
            title.innerHTML = titleText;
          }
        }
        
        switch (index) {
          case 1:
            if (index === 1) {
              if (container.querySelector(`[data-highlight-panel-desktop-1]`) != null || container.querySelector(`[data-highlight-panel-1]`) != null) {
                // desktop panel 1
                let panel1Desktop = container.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let panelText = panel1Desktop ? panel1Desktop.querySelector('.highlights-text') : null
                let panelImage = panel1Desktop ? panel1Desktop.querySelector('.highlights-image img') : null
                let panelList = panel1Desktop ? panel1Desktop.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                let highlightList = highlight.tab_content[0].list.map((item) => {
                  return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                })
                if (panelList) {
                  panelList.innerHTML = ''
                  panelList.innerHTML = highlightList.join('')
                }

                // mobile panel 1
                let panel1 = container.querySelector(`[data-highlight-panel-${index}]`)
                panelText = panel1 ? panel1.querySelector('.highlights-text') : null
                panelImage = panel1 ? panel1.querySelector('.highlights-image img') : null
                panelList = panel1 ? panel1.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                highlightList = highlight.tab_content[0].list.map((item) => {
                  return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                })
                if (panelList) {
                  panelList.innerHTML = ''
                  panelList.innerHTML = highlightList.join('')
                }
              }
            }
          case 2:
            if (index === 2) {
              if (container.querySelector(`[data-highlight-panel-desktop-2]`) != null || container.querySelector(`[data-highlight-panel-2]`) != null) {
                // desktop panel 2
                let panel2Desktop = container.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let panelText = panel2Desktop ? panel2Desktop.querySelector('.highlights-text') : null
                let panelImage = panel2Desktop ? panel2Desktop.querySelector('.highlights-image img') : null
                let panelList = panel2Desktop ? panel2Desktop.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                let highlightList = highlight.tab_content[0].list.map((item) => {
                  return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                })
                if (panelList) {
                  panelList.innerHTML = ''
                  panelList.innerHTML = highlightList.join('')
                }

                // mobile panel 2
                let panel2 = container.querySelector(`[data-highlight-panel-${index}]`)
                panelText = panel2 ? panel2.querySelector('.highlights-text') : null
                panelImage = panel2 ? panel2.querySelector('.highlights-image img') : null
                panelList = panel2 ? panel2.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text 
                }

                // Update panelImage
                if (panelImage) {
                  panelImage.setAttribute('src', highlight.tab_content[0].image[0].src)
                  panelImage.setAttribute('alt', highlight.tab_content[0].image[0].alt)
                  panelImage.setAttribute('height', highlight.tab_content[0].image[0].height + 'px')
                  panelImage.setAttribute('width', highlight.tab_content[0].image[0].width + 'px')
                }

                // Update panelList
                highlightList = highlight.tab_content[0].list.map((item) => {
                  return `
                  <li>
                    <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                    ${item.text}
                  </li>
                  `
                })
                if (panelList) {
                  panelList.innerHTML = ''
                  panelList.innerHTML = highlightList.join('')
                }
              }
            }
          case 3:
            if (index === 3) {
              if (container.querySelector(`[data-highlight-panel-desktop-3]`) != null || container.querySelector(`[data-highlight-panel-3]`) != null) {
                // desktop panel 3
                let panel3desktop = container.querySelector(`[data-highlight-panel-desktop-3]`)

                // mobile panel 3
                let panel3 = container.querySelector(`[data-highlight-panel-3]`)

                if (matchingProduct.type == 'bundle') {
                  document.addEventListener('linked-product:updated', function(){
                    const bundleJSON = JSON.parse(document.querySelector("#bundle-json")?.innerHTML)
                    const bundleProducts = bundleJSON.products
                    const bundleItemsWrapper = document.querySelector('[data-bundle-items-container]')
                    const bundleItemsMobileWrapper = document.querySelector('[data-bundle-items-mobile-container]')
                    let bundleContainer = null
                    if (bundleItemsWrapper) {
                      bundleContainer = bundleItemsWrapper.querySelector('[data-bundle-items]')
                    }
                    let bundleContainerMobile = null
                    if (bundleItemsMobileWrapper) {
                      bundleContainerMobile = bundleItemsMobileWrapper?.querySelector('[data-bundle-items-mobile]')
                    }

                    if (bundleContainer) {
                      bundleContainer.innerHTML = '';
                    }
                    
                    if (bundleContainerMobile) {
                        bundleContainerMobile.innerHTML = '';
                    }

                    for (let i = 0; i < bundleProducts.length; i++) {
                      let product = bundleProducts[i]
                      let item = document.createElement('div')
                      item.classList.add('bundle-item')
                      let productTitle = product.product_title
                      let variantTitle = product.variant_title
                      let featuredImage = product.product_images[0].src
                      let variantImage = product.variant_featured_image
                      let url = product.url
                      if (variantTitle.toLowerCase() !== 'default title') {
                        item.innerHTML = `
                          <div class='bundle-item-inner'>
                            <a href='${url}'>
                            <div class='bundle-item-img-container'>
                              <img class='bundle-item-img' src='${variantImage}' alt='${productTitle}'></div>
                              <h6 class='bundle-item-title'>${productTitle}</h6>
                            </a>
                          </div>
                        `
                      } else {
                        item.innerHTML = `
                          <div class='bundle-item-inner'>
                            <a href='${url}'>
                            <div class='bundle-item-img-container'>
                              <img class='bundle-item-img' src='${featuredImage}' alt='${productTitle}'></div>
                              <h6 class='bundle-item-title'>${productTitle}</h6>
                            </a>
                          </div>
                        `
                      }
                
                      bundleContainer?.appendChild(item)
                      let itemClone = item.cloneNode(true)
                      bundleContainerMobile?.appendChild(itemClone)
                    }
                  })
                } else {
                  if (highlight.tab_content) {
                    let tabContent = highlight.tab_content.map((item) => {
                      return `
                      <div class="dimensions-item">
                        <img src="${item.image[0].src}" loading="lazy" alt="${item.image[0].alt}" height="${item.image[0].height}" width="${item.image[0].width}"> 
                        <div class="dimensions-text">
                          ${item.text}
                        </div>
                      </div>
                    `
                    })
                    if (panel3desktop) {
                      panel3desktop.innerHTML = ''
                      panel3desktop.innerHTML = tabContent.join('')
                    }
                    if (panel3) {
                      panel3.innerHTML = ''
                      panel3.innerHTML = tabContent.join('')
                    }
                  }
                }
              }
            }
          case 4:
            if (index === 4) {
              if (container.querySelector(`[data-highlight-panel-desktop-4]`) != null || container.querySelector(`[data-highlight-panel-4]`) != null) {
                // desktop panel 4
                let panel4Desktop = container.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let panelText = panel4Desktop ? panel4Desktop.querySelector('.highlights-text') : null
                let panelHeader = panel4Desktop ? panel4Desktop.querySelector('.highlights-list h3') : null
                let panelList = panel4Desktop ? panel4Desktop.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelHeader
                if (panelHeader) {
                  panelHeader.innerText = highlight.tab_content[0].heading
                }

                // Update panelList
                let highlightList = highlight.tab_content[0].list.map((item) => {
                  return `
                <li>
                  <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                  ${item.text}
                </li>
                `
                })
                if (panelList) {
                  panelList.innerHTML = ''
                  panelList.innerHTML = highlightList.join('')
                }

                // mobile panel 4
                let panel4 = container.querySelector(`[data-highlight-panel-${index}]`)
                panelText = panel4 ? panel4.querySelector('.highlights-text') : null
                panelHeader = panel4 ? panel4.querySelector('.highlights-list h3') : null
                panelList = panel4 ? panel4.querySelector('.highlights-list ul') : null

                // update panelText
                if (panelText) {
                  panelText.innerHTML = highlight.tab_content[0].text
                }

                // Update panelHeader
                if (panelHeader) {
                  panelHeader.innerText = highlight.tab_content[0].heading
                }

                // Update panelList
                highlightList = highlight.tab_content[0].list.map((item) => {
                  return `
                <li>
                  <img src="${item.image[0].src}" alt=${item.image[0].alt} height="${item.image[0].height}" width="${item.image[0].width}" loading="lazy">
                  ${item.text}
                </li>
                `
                })
                if (panelList) {
                  panelList.innerHTML = ''
                  panelList.innerHTML = highlightList.join('')
                }
              }
            }
            case 5:
              if (index === 5) {
                // the selectors in here have been changed from the container context as this has moved outside of the normal highlight panel on the 2.0 upgrade
                if (document.querySelector(`[data-highlight-panel-desktop-5]`) != null || document.querySelector(`[data-highlight-panel-5]`) != null) {
                  // desktop panel 5
                  let panel5Desktop = document.querySelector(`[data-highlight-panel-desktop-${index}]`)
                  if (panel5Desktop) {
                    panel5Desktop.innerHTML = highlight.tab_content
                  }
                  
                  // mobile panel 5
                  let panel5 = document.querySelector(`[data-highlight-panel-${index}]`)
                  if (panel5) {
                    panel5.innerHTML = highlight.tab_content
                  }
                }
              }
            case 6:
            if (index === 6) {
              // the selectors in here have been changed from the container context as this has moved outside of the normal highlight panel on the 2.0 upgrade
              if (document.querySelector(`[data-highlight-panel-desktop-6]`) != null || document.querySelector(`[data-highlight-panel-6]`) != null) {
                // desktop panel 5
                let panel6Desktop = document.querySelector(`[data-highlight-panel-desktop-${index}]`)
                let highlightTabContent = highlight.tab_content.replaceAll('--', '<span class="circle filled"></span>').replaceAll('()', '<span class="circle empty"></span>')
                if (panel6Desktop) {
                  panel6Desktop.innerHTML = highlightTabContent
                }
                
                // mobile panel 5
                let panel6 = document.querySelector(`[data-highlight-panel-${index}]`)
                if (panel6) {
                  panel6.innerHTML = highlightTabContent
                }
              }
            }
        }
      })
    }
  }

  //Method to update the product features section based on color selected
  updateProductFeatures(matchingProduct) {
    if (this.productFeatures && matchingProduct) {
      const featuresContainer = $('product-features .slide-track')
      if (!featuresContainer) return

      let features = matchingProduct.features.map((feature, index) => {
        if (feature.image[0].src != "" || feature.description != "" || feature.title != "") {
          return `
          <div class="item" data-originalitemindex="${index}">
            <div class="feature-wrap animation">
              <div class="feature-image animation">
              <img
              class=""
              sizes="auto"
              src="${feature.image[0].src}"
              srcset="${feature.image[0].src}"
              height=""
              width=""
            >
              </div>
              <div class="info animation">
                <div class="feature-title" style="min-height: 28px;">${feature.title}</div>
                <div class="feature-description">${feature.description}</div>
              </div>
            </div>
          </div>
          `
        }
      })

      let slickOptions = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        centerPadding: '230px',
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnFocus: false, 
        pauseOnHover: true,
        appendArrows: "product-features .desktop-arrow-container",
        arrows: true,
        prevArrow: '<button class="prev-button"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 48.5693C37.7025 48.5693 48 38.2719 48 25.5693C48 12.8668 37.7025 2.56934 25 2.56934C12.2975 2.56934 2 12.8668 2 25.5693C2 38.2719 12.2975 48.5693 25 48.5693ZM25 50.5693C38.8071 50.5693 50 39.3765 50 25.5693C50 11.7622 38.8071 0.569336 25 0.569336C11.1929 0.569336 0 11.7622 0 25.5693C0 39.3765 11.1929 50.5693 25 50.5693Z" fill="#19341A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.4887 17.9985L37.8526 24.3624C38.2431 24.7529 38.2431 25.3861 37.8526 25.7766L31.4887 32.1406C31.0981 32.5311 30.465 32.5311 30.0744 32.1406C29.6839 31.7501 29.6839 31.1169 30.0744 30.7264L34.7313 26.0695H12.8555V24.0695H34.7313L30.0744 19.4127C29.6839 19.0221 29.6839 18.389 30.0744 17.9985C30.465 17.6079 31.0981 17.6079 31.4887 17.9985Z" fill="#19341A"/></svg></button>',
        nextArrow: '<button class="next-button"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 48.5693C37.7025 48.5693 48 38.2719 48 25.5693C48 12.8668 37.7025 2.56934 25 2.56934C12.2975 2.56934 2 12.8668 2 25.5693C2 38.2719 12.2975 48.5693 25 48.5693ZM25 50.5693C38.8071 50.5693 50 39.3765 50 25.5693C50 11.7622 38.8071 0.569336 25 0.569336C11.1929 0.569336 0 11.7622 0 25.5693C0 39.3765 11.1929 50.5693 25 50.5693Z" fill="#19341A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M31.4887 17.9985L37.8526 24.3624C38.2431 24.7529 38.2431 25.3861 37.8526 25.7766L31.4887 32.1406C31.0981 32.5311 30.465 32.5311 30.0744 32.1406C29.6839 31.7501 29.6839 31.1169 30.0744 30.7264L34.7313 26.0695H12.8555V24.0695H34.7313L30.0744 19.4127C29.6839 19.0221 29.6839 18.389 30.0744 17.9985C30.465 17.6079 31.0981 17.6079 31.4887 17.9985Z" fill="#19341A"/></svg></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerMode: true,
              centerPadding: '150px',
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              centerMode: true,
              centerPadding: '60px',
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      }

      $('product-features .slide-track.slick-initialized').slick('destroy');
      featuresContainer.html('')
      featuresContainer.html (features.join(''))
      $('product-features .slide-track:not("slick-initialized")').slick(slickOptions);
      $('product-features .slide-track').slick('slickGoTo', 0);
    }
  }

  // Method to update the product collection video
  updateProductCollectionVideo(matchingProduct) {
    if (!this.productCollectionVideo || !matchingProduct) return

    const videoContainer = this.productCollectionVideo.querySelector('.pdp-video-wrap')
    if (!videoContainer) return

    // Check if matchingProduct.video exists and has at least one entry
    if (!matchingProduct.video || matchingProduct.video.length === 0) return

    const videoUrl = matchingProduct.video[0].src
    const isExternalVideo = videoUrl.includes('youtube') || videoUrl.includes('vimeo')
    const videoPoster = this.productCollectionVideo.querySelector('[data-video-poster]')

    // Common logic for show-poster class
    if (videoPoster) {
      videoContainer.classList.add('show-poster')
    } else {
      videoContainer.classList.remove('show-poster')
    }

    // Function to initialize play button functionality for non-external videos
    function initPlayButton() {
      const triggerButton = videoContainer.querySelector('.trigger-btn')
      if (triggerButton) {
        triggerButton.addEventListener('click', function () {
          const videoPosterElement = videoContainer.querySelector('.video-poster')
          const videoElement = videoContainer.querySelector('[data-video]')


          if (videoPosterElement) {
            videoPosterElement.style.display = 'none'
          }

          if (videoElement) {
            videoElement.style.visibility = 'visible'
            videoElement.controls = true
            videoElement.play()
          }
        })
      }
    }

    if (isExternalVideo) {
      videoContainer.classList.add('video-external')
      videoContainer.classList.remove('video-inline')
      // Fetch poster URL from matchingProduct
      const posterUrl = matchingProduct.video[0].image
      //if poster present

      if (posterUrl) {
        videoContainer.classList.add('show-poster')

        videoContainer.innerHTML = `
          <div id="pdp-video-player"></div>
          <div class="video-poster" style="background-color: rgb(255, 255, 255); background-image: url('${posterUrl}');" data-bgset="${posterUrl}" data-video-poster>
            <button type="button" class="trigger-btn" aria-label="Play video">
                <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-trigger" viewBox="0 0 32 32">
                  <path fill="#000000" d="M12.8,8.8l9.6,7.2l-9.6,7.2V8.8z M32,16c0,2.9-0.7,5.6-2.2,8.1c-1.4,2.4-3.3,4.3-5.7,5.7C21.6,31.3,18.9,32,16,32s-5.6-0.7-8.1-2.2c-2.4-1.4-4.3-3.3-5.7-5.7C0.7,21.6,0,18.9,0,16c0-2.9,0.7-5.6,2.2-8.1c1.4-2.4,3.3-4.3,5.7-5.7C10.4,0.7,13.1,0,16,0c2.9,0,5.6,0.7,8.1,2.2c2.4,1.4,4.3,3.3,5.7,5.7C31.3,10.4,32,13.1,32,16z M28.8,16c0-2.3-0.6-4.5-1.8-6.5c-1.1-1.9-2.7-3.5-4.6-4.6c-2-1.2-4.2-1.8-6.5-1.8s-4.5,0.6-6.5,1.8C7.6,6.1,6.1,7.6,4.9,9.5c-1.2,2-1.8,4.2-1.8,6.5s0.6,4.5,1.8,6.5c1.1,1.9,2.7,3.5,4.6,4.6c2,1.2,4.2,1.8,6.5,1.8s4.5-0.6,6.5-1.8c1.9-1.1,3.5-2.7,4.6-4.6C28.3,20.5,28.8,18.3,28.8,16z"></path>
                </svg>
            </button>
          </div>
          `

        let player
        Simplistic.YoutubePlayer.loadVideo(function () {
          player = new YT.Player('pdp-video-player', {
            playerVars: {
              allowfullscreen: 1,
              frameborder: 0,
              controls: Simplistic.getQueryParam('controls', `${matchingProduct.video[0].src}`) || 1,
              autohide: 1,
              rel: Simplistic.getQueryParam('rel', `${matchingProduct.video[0].src}`) || 0
            },
            videoId: Simplistic.YoutubePlayer.extractVideoID(`${matchingProduct.video[0].src}`),
            events: {
              onReady: onPlayerReady
            }
          })
        })

        function onPlayerReady(event) {
          $('.pdp-video .trigger-btn').click(function () {
            $('.pdp-video .video-poster').hide()
            $('.pdp-video #pdp-video-player').css('visibility', 'visible')
            player.playVideo()
          })
        }
      }
      //if no poster present
      else {
        videoContainer.innerHTML = `
            <iframe
                class="pdp-video-element"
                src="${videoUrl}"
                frameborder="0"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        `
      }
    } else {
      videoContainer.classList.remove('video-external')
      videoContainer.classList.add('video-inline')

      // Fetch poster URL from matchingProduct
      const posterUrl = matchingProduct.video[0].image

      // Create videoPoster div
      const videoPosterDiv = `
        <div class="video-poster" style="background-color: rgb(255, 255, 255); background-image: url('${posterUrl}');" data-bgset="${posterUrl}" data-video-poster>
            <button type="button" class="trigger-btn" aria-label="Play video">
                <svg aria-hidden="true" tabindex="-1" role="presentation" class="icon icon-trigger" viewBox="0 0 32 32">
                  <path fill="#000000" d="M12.8,8.8l9.6,7.2l-9.6,7.2V8.8z M32,16c0,2.9-0.7,5.6-2.2,8.1c-1.4,2.4-3.3,4.3-5.7,5.7C21.6,31.3,18.9,32,16,32s-5.6-0.7-8.1-2.2c-2.4-1.4-4.3-3.3-5.7-5.7C0.7,21.6,0,18.9,0,16c0-2.9,0.7-5.6,2.2-8.1c1.4-2.4,3.3-4.3,5.7-5.7C10.4,0.7,13.1,0,16,0c2.9,0,5.6,0.7,8.1,2.2c2.4,1.4,4.3,3.3,5.7,5.7C31.3,10.4,32,13.1,32,16z M28.8,16c0-2.3-0.6-4.5-1.8-6.5c-1.1-1.9-2.7-3.5-4.6-4.6c-2-1.2-4.2-1.8-6.5-1.8s-4.5,0.6-6.5,1.8C7.6,6.1,6.1,7.6,4.9,9.5c-1.2,2-1.8,4.2-1.8,6.5s0.6,4.5,1.8,6.5c1.1,1.9,2.7,3.5,4.6,4.6c2,1.2,4.2,1.8,6.5,1.8s4.5-0.6,6.5-1.8c1.9-1.1,3.5-2.7,4.6-4.6C28.3,20.5,28.8,18.3,28.8,16z"></path>
                </svg>
            </button>
        </div>
      `

      // Clear the videoContainer and reset for non-external video
      videoContainer.innerHTML = videoPosterDiv + `<video data-video class="pdp-video-element" controls poster="${posterUrl}"></video>`

      const videoElement = videoContainer.querySelector('[data-video]')
      const videoSrcElement = document.createElement('source')
      videoSrcElement.setAttribute('data-video-src', '')
      videoSrcElement.setAttribute('src', videoUrl)
      if (videoElement) {
        videoElement.appendChild(videoSrcElement)
        videoElement.load()
      }

      // Call the play button initialization function
      initPlayButton()
    }
  }

  // Method to updated the "recently added" flair
  updateRecentlyAddedCount(matchingProduct) {
    if(matchingProduct.recently_added_count && this.productRecentlyAddedCount) {
      this.productRecentlyAddedCount.textContent = matchingProduct.recently_added_count
    }
    if (this.productRecentlyAddedContainer) {
      this.productRecentlyAddedContainer.classList.toggle('hide', Number(matchingProduct.recently_added_count) <= 0)
    }
  }

  updateProductCallouts(matchingProduct) {
    if (!matchingProduct) return;

    // Helper function to handle special conditions for callout texts
    const handleSpecialConditions = (element, text, color) => {
      if (!element || !text) return;

      if (text.toLowerCase().includes('limited time only') || text.toLowerCase().includes('limited time offer') || text.toLowerCase().includes('limited quantities') || text.toLowerCase().includes('quantities are limited')) {
        element.style.color = '#ab252b';
      } else if (text.toLowerCase().includes('free shipping')) {
        element.style.color = '#19341a';
      } else {
        element.style.color = color;
      }
    };

    // Helper function to calculate discount percentage
    const calculateDiscountPercentage = (compareAtPrice, regularPrice) => {
      if (compareAtPrice > regularPrice) {
        compareAtPrice = parseFloat(compareAtPrice).toFixed(2);
        regularPrice = parseFloat(regularPrice).toFixed(2);
        
        const discountDifference = compareAtPrice - regularPrice;
        const percentage = (discountDifference / compareAtPrice) * 100;
        return Math.floor(percentage);
      }
      return 0;
    };

    // Function to update callout text and color
    const updateCallout = (container, text, color) => {
      if (!container) return;

      // Create or get the child element
      let element = container.firstElementChild;
      if (!element) {
        element = document.createElement('p');
        container.appendChild(element);
      }

      element.textContent = text || '';
      element.style.color = text ? color || '' : '';

      // Only add class if text has actual content
      if (text && text.trim() !== '') {
        element.classList.add('product-callout');
      } else {
        element.classList.remove('product-callout');
        element.style.color = '';
      }

      return element;
    };

    // Update calloutTextOne
    if (this.calloutTextOne) {
      const elementOne = updateCallout(this.calloutTextOne, matchingProduct.calloutTextOne, matchingProduct.calloutColorOne);
      handleSpecialConditions(elementOne, matchingProduct.calloutTextOne, matchingProduct.calloutColorOne);
    }

    // Update calloutTextTwo
    if (this.calloutTextTwo) {
      const elementTwo = updateCallout(this.calloutTextTwo, matchingProduct.calloutTextTwo, matchingProduct.calloutColorTwo);
      handleSpecialConditions(elementTwo, matchingProduct.calloutTextTwo, matchingProduct.calloutColorTwo);
    }

    // Update calloutTextThree
    if (this.calloutTextThree) {
      let calloutText = matchingProduct.calloutTextThree || '';
      let calloutColor = matchingProduct.calloutColorThree || '';

      // If calloutText is not provided, proceed with the logic to determine it
      if (!calloutText) {
        const variant = matchingProduct.variants ? matchingProduct.variants[0] : null;

        if (variant) {
          const regularPriceLabel = matchingProduct.regularPriceLabel ? matchingProduct.regularPriceLabel.toLowerCase() : '';

          let regularPrice = variant.price;
          if (typeof regularPrice === 'string') {
            regularPrice = parseFloat(regularPrice.replace(/[^0-9.-]+/g, ''));
          }
      
          let compareAtPrice = variant.compare_at_price;
          if (compareAtPrice && typeof compareAtPrice === 'string') {
            compareAtPrice = parseFloat(compareAtPrice.replace(/[^0-9.-]+/g, ''));
          }

          if ((regularPriceLabel === 'clearance' || regularPriceLabel === 'sale') && compareAtPrice > regularPrice) {
            const discountPercentage = calculateDiscountPercentage(compareAtPrice, regularPrice);
            calloutText = `${discountPercentage}% Off`;
            calloutColor = '#ab252b';
          } else if (calloutText.toLowerCase().includes('limited quantities') || calloutText.toLowerCase().includes('quantities are limited')) {
            calloutColor = '#ab252b';
          }
        }
      }

      const elementThree = updateCallout(this.calloutTextThree, calloutText, calloutColor);
      handleSpecialConditions(elementThree, calloutText, calloutColor);
    }
  }  

  updateAboveTitleText(matchingProduct) {
    if (this.aboveTitleText && matchingProduct) {
      this.aboveTitleText.innerHTML = matchingProduct.aboveTitleText
    } else {
      this.aboveTitleText.innerHTML = ''
    }
  }  
    
  // Method to update the state of the ATC button based on selected color
  updateATCState(selectedOption) {
    // Check if the selected option is OOS
    if (selectedOption?.classList.contains('soldout')) {
      // If disabled, hide the product available element
      this.productAvailableElement?.classList.add('hide')
      this.productStockMessage?.classList.add('hide')

      // Show the product soldout element
      this.productSoldOutElement?.classList.remove('hide')
    } else {
      // If not disabled, enable the product available element
      this.productAvailableElement?.classList.remove('hide')
      this.productStockMessage?.classList.remove('hide')

      // Hide the product soldout element
      this.productSoldOutElement?.classList.add('hide')
    }
  }

  // method to update the bundle json object used for the bundle functionality 
  async updateBundleJSON(matchingProduct) {  
    // Get the bundle-json element
    const bundleJsonElement = document.getElementById('bundle-json');
  
    // Check if the element exists
    if (bundleJsonElement) {
      const productHandle = matchingProduct.handle;
  
      if (productHandle) {
        try {
          const responseText = await this.fetchProduct(productHandle);
          const bundleJSON = responseText['bundle-json'];
  
          if (bundleJSON) {
            // Parse bundleJSON as a DOM element
            const parsedBundleJSON = new DOMParser().parseFromString(bundleJSON, 'text/html');
  
            // Extract the contents of the #bundle-json element
            const targetContent = parsedBundleJSON.querySelector('#bundle-json').textContent;
  
            // Update the innerHTML of the target element
            bundleJsonElement.innerHTML = targetContent;
          }
        } catch (error) {
          console.error('Error updating bundle JSON:', error);
        }
      }
    } else {
      console.error('bundle-json element not found');
    }
  }  

  // helper function to fetch the bundle json section using section rendering API
  async fetchProduct(handle) {
    const url = new URL(`/products/${handle}`, window.location.origin);
    url.searchParams.set('sections', 'bundle-json');

    return fetch(url)
      .then((response) => response.json())
      .then((responseText) => {
        return responseText
      })
      .catch(console.error);
  }

  updateInStockMessage(matchingProduct) {
    let stockMessage = matchingProduct.stockMessage

    if (matchingProduct.freeShipping) {
      stockMessage = matchingProduct.freeShipping
    } else {
    }
    
    if (stockMessage) {
      this.inStockMessageElement.innerHTML = stockMessage;
    }
  }  

  updateProductOverlayBadge(matchingProduct) {
    if (!this.productOverlayBadge || !this.productOverlayBadgeText || !matchingProduct) return;

    const badgeData = matchingProduct.overlay_badge;
    
    if (badgeData.show) {
      this.productOverlayBadge.style.display = 'block';
      this.productOverlayBadge.style.background = badgeData;
      this.productOverlayBadgeText.textContent = badgeData.text;
    } else {
      this.productOverlayBadge.style.display = 'none';
    }
  }

  /*
   * ##################################
   * RENDERING
   * ##################################
   */
  // Method to render color options for the linked products
  renderLinkedProductOptions() {
    if (!this.container) return
    this.container.innerHTML = '' // Clear the existing options
    const colorOptions = this.getColorOptions() // Get the color options
    const baseFileUrl = window.baseFileUrl // Base file URL for images
    let colorLabel = this.productColorLabel
    if (colorOptions) {
      // For each color option, create a list item and append it to the container
      colorOptions.forEach((colorOption, index) => {
        const swatchElement = this.createSwatchElement(colorOption, index, baseFileUrl, colorLabel)
        this.container.appendChild(swatchElement)
      })
    }
    //get selectedIndex of checked input on page load
    let selectedIndex = this.container.querySelector('input:checked').dataset.index
    this.productColorLabel.setAttribute('data-selected-index', selectedIndex)
  }

  // Method to create a list item for each color option
  createSwatchElement(colorOption, index, baseFileUrl, colorLabel) {
    let dataElement = this.data.products.find((product) => product.title.includes(colorOption))
    let variantAvailable = dataElement.variants[0].available
    let variantId = dataElement.variants[0].id
    let bundleOOS = dataElement.bundle_OOS
    let colorFiltered = `${colorOption.toLowerCase().split(' ').join('-')}`
    let colorLabelSelected = colorLabel.dataset.colorLabel
    const swatchElement = document.createElement('div')
    swatchElement.classList.add('swatch-element', 'color', colorFiltered, variantAvailable ? 'available' : 'soldout')
    swatchElement.setAttribute('data-value', colorOption)
    swatchElement.addEventListener('click', this.handleColorOptionClick.bind(this))
    swatchElement.innerHTML = this.getListItemHTML(colorOption, index, `color-${colorFiltered}`, colorFiltered, variantId, colorLabelSelected)
    if (bundleOOS) {
      swatchElement.classList.add('soldout')
    }
    return swatchElement
  }

  // Method to return HTML for list item
  getListItemHTML(colorOption, index, colorClass, colorFiltered, variantId, colorLabelSelected) {
    return `
    <div class="tooltip" aria-hidden="true" data-color-label>${colorOption}</div>
      <input
        class="visuallyhidden"
        id="swatch-${variantId}-${index}-${colorFiltered}"
        type="radio"
        name="option-${index}"
        value="${colorOption}"
        data-index="${index}"
        ${colorOption === colorLabelSelected ? 'checked' : ''}
      >
      <label
        class="animation color ${colorClass}"
        role="button"
        for="swatch-${variantId}-${index}-${colorFiltered}"
      >
        <span class="visuallyhidden"
          >Select ${colorOption}
        </span>
        <div class="cross"></div>
      </label>
    </div>
    `
  }

  // Method to render addon products for the linked products
  renderAddonProductOptions() {
    if (!this.productAddonsContainer) return;
    this.productAddonsContainer.innerHTML = ''; // Clear the existing options
    const addonOptions = this.getAddonOptions(); // Get the addon options
    let selectedIndex = this.productColorLabel.dataset.selectedIndex;

    // Check if addonOptions at selectedIndex exists
    if (addonOptions && addonOptions[selectedIndex].length != 0) {
        this.productAddonsHeading.classList.remove('hide');
        
        addonOptions[selectedIndex].forEach((addonOption) => {
            const addonItem = this.createAddonItem(addonOption);
            this.productAddonsContainer.appendChild(addonItem);

            let contents = this.productAddonsContainer.querySelectorAll('.addon-recommendations__content');
            let min_height = 0
    
            if(contents){
            contents.forEach(content => {
                if (content.offsetHeight > min_height){
                  min_height = content.offsetHeight;
                }
              })
              let root = document.querySelector(':root');
              root.style.setProperty('--addon-content-height', min_height + "px")
            }

        });
    } else {
        this.productAddonsHeading.classList.add('hide');
    }
  }

  // Method to create a list item for each color option
  createAddonItem(addonOption) {
    let addonAvailable = addonOption.main_variant.available
    if (!addonAvailable) {
      addonAvailable = 'hide'
    }
    let addonId = addonOption.main_variant.id
    let addonImgSrc = addonOption.main_image[0].src
    let addonImgAlt = addonOption.main_image[0].alt.replace(/"/g, '&quot;')
    let addonTitle
    if (addonOption.main_variant.title === "Default Title") {
      addonTitle = addonOption.main_product.title.replace(/"/g, '&quot;')
    } else {
      addonTitle = addonOption.main_product.title.replace(/"/g, '&quot;') + " - " + addonOption.main_variant.title.replace(/"/g, '&quot;')
    }
  
    function cleanTitle(title) {
      const match = title.match(/^(.+)\|\s*([^-]+)\s*-\s*\2$/);
      if (match) {
        return match[1].trim() + '| ' + match[2].trim();
      }
      return title;
    }
  
    addonTitle = cleanTitle(addonTitle);
    
    let addonPrice = addonOption.main_price
    const addonItem = document.createElement('div')
    addonItem.classList.add('addon-recommendations__item', addonAvailable)
    addonItem.innerHTML = this.getAddonItemHTML(addonId, addonTitle, addonPrice, addonImgSrc, addonImgAlt)
    return addonItem
  }  

  // Method to return HTML for list item
  getAddonItemHTML(addonId, addonTitle, addonPrice, addonImgSrc, addonImgAlt) {
    return `
    <img src="${addonImgSrc}" alt="${addonImgAlt}" height="100" width="100">
    <div class="addon-recommendations__content">
      <p class="addon-recommendations__title">
        ${addonTitle}
      </p>
      <p class="addon-recommendations__price">
        ${addonPrice}
      </p>
      <form
        method="post"
        class="variants add-to-cart-form"
        enctype="multipart/form-data"
      >
        <input type="hidden" name="id" value="${addonId}">
        <input type="hidden" name="quantity" value="1">
        <button type="submit" name="add" class="btn">Add to cart</button>
      </form>
    </div>
    `
  }

  /*
   * ##################################
   * URL MANAGEMENT
   * ##################################
   */
  // Method to generate a new URL based on the product title associated with the selected color
  buildNewUrl(state, matchingProduct) {
    if (!matchingProduct) return
    const url = matchingProduct.url
    return `${window.location.origin}${url}`
  }

  /*
   * ##################################
   * STATE MANAGEMENT
   * ##################################
   */
  // Method to update the state of the page based on the selected color
  updatePageState(state) {
    const matchingOption = this.container && this.container.querySelector(`input[value="${state.color}"]`)
    if (matchingOption) {
      this.updateActiveSwatch(matchingOption) // Update the active swatch
    }
  }
}

// Function to initialize the page
const initializePage = () => {
  const handler = new LinkedProducts('linked-products-json');
  handler.initializeData();
  handler.renderLinkedProductOptions();
  handler.renderAddonProductOptions()
}

window.onload = initializePage;